import * as Sentry from "@sentry/nextjs";
import { NextPageContext } from "next";
import { ErrorInfo } from "react";
import { jwtPayload } from "@insightfulscience/shared-utils/jwt/jwtPayload";
import ApplicationError from "@insightfulscience/smart-react/ApplicationError";

import { publicConfig } from "./config";
import { PersistentStorage } from "./services/persistentStorage";
import { ENV_LOCAL, ENV_DEV } from "./constants";

const { SENTRY_DSN, ENV } = publicConfig;

export const getSentryEnvName = () =>
	ENV === ENV_DEV ? "development" : (ENV || ENV_LOCAL).toLowerCase();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const shouldIgnore = (error: any): boolean =>
	error == null || (error instanceof ApplicationError && error.code !== 500);

export const notifySentry = (
	err: Error,
	errorInfo: ErrorInfo,
	context: NextPageContext | null,
) => {
	if (!SENTRY_DSN) return;
	if (shouldIgnore(err)) return;

	const { token } = PersistentStorage(context);
	const user = jwtPayload<object>(token.read());

	Sentry.setUser(user);
	Sentry.addBreadcrumb({
		category: "component.stack",
		level: "debug",
		data: errorInfo,
	});

	Sentry.captureException(err);
};
